import { gql } from '@apollo/client';

export const addClubVendorMutation = gql`
  mutation AddClubVendor($input: AddClubVendorInput!) {
    addClubVendor(input: $input) {
      vendorId
    }
  }
`;
